import { MessageCircle, MapPin, UserCheck } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY } from "../../data/content";
import { Reveal } from "./Reveal";

const BG = "https://images.unsplash.com/photo-1627764574958-fb54cd7d7448";

const POINTS = [
  { icon: MapPin, t: "Solo en Asturias", d: "Consulta presencial. Ayuda exclusivamente en Asturias." },
  { icon: UserCheck, t: "Sin intermediarios", d: "Sin gabinetes ni terceros. Hablas directamente conmigo." },
  { icon: MessageCircle, t: "Respuesta directa", d: "Te contesto yo misma por WhatsApp y concretamos cita." },
];

export const Contact = () => (
  <section id="contacto" data-testid="contact-section" className="relative py-24 md:py-32 overflow-hidden">
    <div className="absolute inset-0 -z-10">
      <img src={BG} alt="Lectura de cartas de tarot" className="w-full h-full object-cover opacity-25" />
      <div className="absolute inset-0 bg-[#05030A]/85" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,#2D1350_0%,transparent_65%)] opacity-60" />
    </div>

    <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Contacto</span>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-[#F3EFE7] tracking-tight">
          Cuéntame qué te ocurre
        </h2>
        <p className="mt-5 max-w-xl mx-auto text-white/75 leading-relaxed">
          El primer paso es hablar. Escríbeme por WhatsApp sin compromiso y te digo con
          sinceridad cómo puedo ayudarte a cambiar tu situación.
        </p>
        <a href={waLink("Hola Luz Sagrada, quiero pedir una consulta.")} target="_blank" rel="noopener noreferrer"
          data-testid="contact-whatsapp-cta"
          className="mt-9 inline-flex items-center gap-3 rounded-full bg-[#25D366] text-white px-9 py-4 font-medium hover:brightness-110 transition-[filter] duration-300">
          <MessageCircle size={20} /> Escríbeme por WhatsApp
        </a>
        <p className="mt-4 text-white/60">{WHATSAPP_DISPLAY}</p>
      </Reveal>

      <div className="mt-16 grid sm:grid-cols-3 gap-5">
        {POINTS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.t} delay={i * 0.08}>
              <div className="rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-md p-6 text-left">
                <Icon className="text-[#C5A059]" size={22} />
                <h3 className="mt-4 font-serif text-xl text-[#F3EFE7]">{p.t}</h3>
                <p className="mt-2 text-sm text-white/65 leading-relaxed">{p.d}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
